import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import {
  mdiWaves,
  mdiCalculatorVariant,
  mdiHorseVariantFast,
  mdiArrowSplitVertical,
  mdiWave,
  mdiTractorVariant,
  mdiEarthBox,
  mdiCalculator 
} from '@mdi/js';
import Icon from '@mdi/react';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import './leftSideMenu.scss';
import { SideNavVM } from 'cd-eft/components/common/SideNav/SideNavVM';

const LeftSideMenuComponent = (props: any) => {
  const history = useHistory();
  const location = useLocation();
  const vm = useRef(new SideNavVM(history, location)).current;
  return (
    <nav className="common-subnav-bar common-side-menu" aria-label="Analysis Menu">
      <div className="text-white">Analysis</div>

      <NavLink to="/analysis/hydrology" activeClassName="active-common-item" className="common-side-menu-button" exact>
        <Icon path={mdiWaves} title="Hydrology" size={1} />
        <div>Hydrology</div>
      </NavLink>

      {vm.history.location.pathname.includes('/analysis/hydrology') ? (
        <>
        <NavLink
          to="/analysis/hydrology/single-watershed"
          activeClassName="active-common-item"
          className="common-side-menu-button single-watershed"
        >
          <Icon path={mdiWave} title="Single Watershed" size={1} />
          <div>Single Watershed</div>
        </NavLink>
        <NavLink
          to="/analysis/hydrology/hydrology-calculator"
          activeClassName="active-common-item"
          className="common-side-menu-button single-watershed"
        >
          <Icon path={mdiCalculator } title="Hydrology Calculator" size={1} />
          <div>Hydrology Calculator</div>
        </NavLink>
        </>
      ) : (
        ''
      )}

      <NavLink to="/analysis/animal-waste" activeClassName="active-common-item" className="common-side-menu-button">
        <Icon path={mdiHorseVariantFast} title="Animal Waste" size={1} />
        <div>Animal Waste</div>
      </NavLink>

      <NavLink to="/analysis/irrigation" activeClassName="active-common-item" className="common-side-menu-button">
        <Icon path={mdiTractorVariant} title="Irrigation" size={1} />
        <div>Irrigation</div>
      </NavLink>

      <NavLink
        to="/analysis/hydraulic-formula"
        activeClassName="active-common-item"
        className="common-side-menu-button"
        data-testid="analysis-menu-formulas"
      >
        <Icon path={mdiCalculatorVariant} title="Formulas" size={1} />
        <div>Formulas</div>
      </NavLink>

      <NavLink
        to="/analysis/waterway-sizing-calculator"
        activeClassName="active-common-item"
        className="common-side-menu-button"
      >
        <Icon path={mdiArrowSplitVertical} title="Waterway Sizing Calculator" size={1} />
        <div>Waterway Sizing Calculator</div>
      </NavLink>
      <NavLink to="/analysis/clipped-dem" activeClassName="active-common-item" className="common-side-menu-button">
        <Icon path={mdiEarthBox} title="Surface" size={1} />
        <div>Clipped DEM</div>
      </NavLink>
    </nav>
  );
};

export const LeftSideAnalysisMenu = observer(LeftSideMenuComponent);
